import React, { useState } from "react";

export default function Navform(props) {

    const handleUpClick=()=>{
    let newtext=text.toUpperCase();
    setText(newtext);
    props.showAlert("converted to Uppercase","success")
    }

    const handleLoClick=()=>{
      let newtext=text.toLowerCase();
      setText(newtext);
      props.showAlert("converted to Lowercase","success")
      }

      const handleSpeakClick = () => {
        let msg = new SpeechSynthesisUtterance();
        msg.text = text;
        window.speechSynthesis.speak(msg);
        props.showAlert("Speaking......","success")
      }

      const handleClearClick = () => {
       let newtext=('');
       setText(newtext);
       props.showAlert("your text is Remove","success")
      }
      
      const handleCopy = () => {
        var text=document.getElementById('exampleFormControlTextarea1');
        text.select();
        navigator.clipboard.writeText(text.value);
        props.showAlert("Your text is Copy","success")
       }
      
    const handleOnChange=(event)=>{
      setText(event.target.value)
    }

    const[text, setText]=useState('');

  return (
    <>
      <div className=" container mb-3 my-3">
        <label htmlFor="exampleFormControlTextarea1" className="form-label">
         {props.heading}
        </label>
        <textarea
          className="form-control" value={text} onChange={handleOnChange}
          id="exampleFormControlTextarea1" 
          rows="8"
        ></textarea>
      </div>
      <button type="button" className="btn btn-outline-primary mx-2 " onClick={handleUpClick}>Convert To Uppercase</button>
      <button type="button" className="btn btn-outline-primary mx-2" onClick={handleLoClick}>Convert To Lowercase</button>
      <button type="button" className="btn btn-outline-primary mx-2" onClick={handleSpeakClick}>Speak</button>
      <button type="button" className="btn btn-outline-primary mx-2" onClick={handleClearClick}>Clear</button>
      <button type="button" className="btn btn-outline-primary mx-2" onClick={handleCopy}>Copy text</button>

      <div className="container my-4">
      <h1>Your text summary</h1>
      <p>{text.split(" ").length > 0 ? `${text.split(" ").length} word And ${text.length} characters` : 'No text entered'}</p>
    <p>{text.split(" ").length > 0 ? `${0.008 * text.split(" ").length} Minutes for reading this text` : 'No text entered'}</p> 
      <div className="container py-2 p-3 bg-info bg-opacity-10 border border-info border-start-0 rounded-end">
      <h2>Preview</h2>
      <p>{text}</p>
      </div> 
      </div>
    </>

  );
}
